import { render, staticRenderFns } from "./ReturnItemEditor.vue?vue&type=template&id=32fbf7c4&scoped=true&"
import script from "./ReturnItemEditor.vue?vue&type=script&lang=js&"
export * from "./ReturnItemEditor.vue?vue&type=script&lang=js&"
import style0 from "./ReturnItemEditor.vue?vue&type=style&index=0&id=32fbf7c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fbf7c4",
  null
  
)

export default component.exports